







import Vue from 'vue';
import { IFooterData } from '@/common/interfaces/footer.interface';
import config from '../../../config';
import FooterDesktop from './subcomponent/FooterDesktop.vue';
import FooterMobile from './subcomponent/FooterMobile.vue';

export default Vue.extend({
  name: `Footer`,
  components: {
    FooterDesktop,
    FooterMobile,
  },
  data(): IFooterData {
    return {
      mobileView: true,
    };
  },
  created(): void {
    window.addEventListener(`resize`, this.reportWindowSize);
  },
  mounted(): void {
    this.reportWindowSize();
  },
  methods: {
    reportWindowSize(): void {
      this.mobileView = window.innerWidth < config.breakpoints.smallDesktop;
    },
  },
});
